import React, { useState, ChangeEvent, useRef, useEffect } from "react";
import { Form, Button, Image, Container, Row, Col } from "react-bootstrap";

interface ImageUploaderProps {
    name?: string;
    label?: string;
    showPreview?: boolean;
    onUpload?: (file: File) => void;
    initialImage?: string;
}

const ImageUploader: React.FC<ImageUploaderProps> = ({
    name = "Logo",
    label = "Upload an image",
    onUpload,
    initialImage
}) => {
    const [preview, setPreview] = useState<string | null>(null);
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        if (initialImage) {
            setPreview(initialImage);
        }
    }, [initialImage]);

    const handleClick = () => {
        fileInputRef.current?.click();
    };

    const handleImageChange = (e: ChangeEvent<HTMLInputElement>) => {
        const selectedFile = e.target.files?.[0];
        if (selectedFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result as string);
            };
            reader.readAsDataURL(selectedFile);
            if (onUpload) {
                onUpload(selectedFile);
            }
        }
    };

    return (
        <Container className="my-4">
            <input
                id="image-uploader-input"
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                ref={fileInputRef}
                onChange={handleImageChange}
            />
            <div
                onClick={handleClick}
                style={{
                    width: "100%",
                    aspectRatio: 1 / 1,
                    backgroundColor: "#dee2e6",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "0.25rem",
                    border: "1px solid #ced4da",
                    cursor: "pointer",
                    overflow: "hidden",
                }}
            >
                {preview ? (
                    <Image
                        src={preview}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                ) : (
                    <span style={{ fontWeight: "bold", color: "#6c757d" }}>{name}</span>
                )}
            </div>
            <label htmlFor="image-uploader-input">{label}</label>
        </Container>
    );
};

export default ImageUploader;